(function () {
  const initProductAccordion = () => {
    const aboutToggleItems = $('.about__accordion-toggle');

    aboutToggleItems.each(function () {
      const currentToggle = $(this);
      const siblingToggles = currentToggle.siblings('.about__accordion-description');

      currentToggle.click(function () {
        if (!currentToggle.hasClass('active')) {
          aboutToggleItems.each(function () {
            const siblingToggle = $(this);
            siblingToggle.removeClass('active');
            siblingToggle.siblings('.about__accordion-description').stop().slideUp(300);
          });

          currentToggle.addClass('active');

          siblingToggles.stop().slideDown(300);
        } else {
          currentToggle.removeClass('active');
          siblingToggles.stop().slideUp(300);
        }
      });
    });
  };

  const initZoomImage = () => {
    const imagesWrapper = document.querySelector('.product-media-modal__content');
    const images = imagesWrapper?.querySelectorAll('.js-image-zoom') || [];

    images.forEach((el) => {
      el.addEventListener('click', (e) => {
        imagesWrapper.classList.toggle('zoom');
      });
    });
  };

  const formatFreeShippingAmount = (value) => {
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = theme.moneyFormat;

    return formatString.replace(placeholderRegex, value);
  };

  const setTotalFreeShipping = () => {
    if (document.querySelector('.js-free-shipping')) {
      const freeShippingTotal = document.querySelector('.free-shipping-total');
      if (freeShippingTotal) {
        const minSpend = Number(freeShippingTotal.dataset.minSpend);
        if (minSpend && minSpend > 0) {
          freeShippingTotal.innerText = `${formatFreeShippingAmount(
            Math.round(minSpend * (Shopify.currency.rate || 1)),
          )}`;
        }
      }
    }
  };

  const revealStickyAddToCart = (section) => {
    if (!section && section.classList.contains('.product-section')) return;
    const buyButtons = section.querySelector('.product__buy-buttons > product-form');
    const stickyBar = section.querySelector('.sticky-add-to-cart');
    const footerBottom = document.querySelector(
      '.shopify-section-group-footer-group .footer__content-bottom',
    );

    if (!stickyBar) return;

    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.01,
    };

    const isElementBelowScroll = (element) => {
      return element ? element.getBoundingClientRect().top > 0 : false;
    };

    const toggleStickyBar = (isVisible) => {
      if (isVisible || isElementBelowScroll(buyButtons)) {
        stickyBar.classList.remove('active');
      } else {
        stickyBar.classList.add('active');
      }
    };

    const handleIntersect = (entries) => {
      const isVisible = entries.some((entry) => entry.isIntersecting);
      toggleStickyBar(isVisible);
    };

    const observer = new IntersectionObserver(handleIntersect, observerOptions);

    if (buyButtons) observer.observe(buyButtons);
    if (footerBottom) observer.observe(footerBottom);
  };

  document.addEventListener('shopify:section:load', function (event) {
    initProductAccordion();
    initZoomImage();
    setTotalFreeShipping();
    revealStickyAddToCart(event.target);
  });

  initProductAccordion();
  initZoomImage();
  setTotalFreeShipping();
  revealStickyAddToCart(document.currentScript.parentElement);
})();

/* === Cards Quest — Plan C v8 : cœur en pseudo ::before (mask-image), pas d'injection JS → zéro layout shift === */
(function () {
  var LABEL_DEFAULT = 'Ajouter à ma wishlist';
  var LABEL_ADDED   = 'Ajouté à ma wishlist';
  /* Heart Material filled, mask-image SVG data URI. Le pseudo ::before est TOUJOURS dans le layout → pas de shift au moment où Swym injecte sa barre. */
  var HEART_MASK = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='2 2 20 20'%3E%3Cpath d='M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z'/%3E%3C/svg%3E\")";

  var css = ''
    + '.product__buy-buttons .swym-button-bar,'
    + '.product__buy-buttons .swym-btn-container,'
    + '.product__buy-buttons .cq-wishlist-placeholder {'
    + '  display: block !important;'
    + '  width: 100% !important;'
    + '  margin: 0 !important;'
    + '  padding: 0 !important;'
    + '}'
    /* Masque la barre Swym tant que mon JS ne l a pas patchée (label + déplacement) — empêche le flash du texte par défaut Swym "Ajouter à Wishlist" qui décale le contenu */
    + '.swym-button-bar:not([data-cq-ready]) {'
    + '  visibility: hidden !important;'
    + '  position: absolute !important;'
    + '  pointer-events: none !important;'
    + '  width: 0 !important;'
    + '  height: 0 !important;'
    + '  overflow: hidden !important;'
    + '  clip: rect(0 0 0 0) !important;'
    + '}'

    /* Bouton wishlist (réel Swym ou placeholder) — style commun */
    + '.product__buy-buttons button.swym-add-to-wishlist,'
    + '.product__buy-buttons .cq-wishlist-placeholder-btn {'
    + '  position: relative;'
    + '  width: 100% !important;'
    + '  height: 50px !important;'
    + '  background: #ffffff !important;'
    + '  color: #131313 !important;'
    + '  border: 1px solid #131313 !important;'
    + '  border-radius: 4px !important;'
    + '  opacity: 1 !important;'
    + "  font-family: 'Poppins', sans-serif !important;"
    + '  font-weight: 700 !important;'
    + '  font-size: 15px !important;'
    + '  letter-spacing: -0.15px !important;'
    + '  text-transform: none !important;'
    + '  display: inline-flex !important;'
    + '  align-items: center !important;'
    + '  justify-content: center !important;'
    + '  gap: 8px !important;'
    + '  padding: 0 22px !important;'
    + '  text-decoration: none !important;'
    + '  cursor: pointer !important;'
    + '  transition: background-color .2s ease, color .2s ease, opacity .2s ease !important;'
    + '}'
    + '.product__buy-buttons button.swym-add-to-wishlist:hover,'
    + '.product__buy-buttons .cq-wishlist-placeholder-btn:hover { background: #f7f7f5 !important; }'

    /* Cœur en pseudo ::before — toujours présent dans le layout dès le 1er paint */
    + '.product__buy-buttons button.swym-add-to-wishlist::before,'
    + '.product__buy-buttons .cq-wishlist-placeholder-btn::before {'
    + '  content: "" !important;'
    + '  display: inline-block !important;'
    + '  width: 18px !important;'
    + '  height: 18px !important;'
    + '  flex: 0 0 18px !important;'
    + '  background-color: currentColor !important;'
    + '  -webkit-mask-image: ' + HEART_MASK + ' !important;'
    + '  mask-image: ' + HEART_MASK + ' !important;'
    + '  -webkit-mask-size: contain !important;'
    + '  mask-size: contain !important;'
    + '  -webkit-mask-repeat: no-repeat !important;'
    + '  mask-repeat: no-repeat !important;'
    + '  -webkit-mask-position: center !important;'
    + '  mask-position: center !important;'
    + '  opacity: 1 !important;'
    + '  flex-shrink: 0;'
    + '}'

    /* Cache le pseudo ::after de Swym (qui causait le double cœur) */
    + '.product__buy-buttons button.swym-add-to-wishlist::after {'
    + '  display: none !important;'
    + '  content: none !important;'
    + '}'

    /* Texte (label) — centré dans le bouton flex */
    + '.product__buy-buttons button.swym-add-to-wishlist .swym-wishlist-cta,'
    + '.product__buy-buttons .cq-wishlist-placeholder-btn .cq-wishlist-label {'
    + '  text-transform: none !important;'
    + '  font-weight: 700 !important;'
    + '  font-size: 15px !important;'
    + '  letter-spacing: -0.15px !important;'
    + "  font-family: 'Poppins', sans-serif !important;"
    + '  color: #131313 !important;'
    + '  margin: 0 !important;'
    + '  padding: 0 !important;'
    + '  opacity: 1 !important;'
    + '  filter: none !important;'
    + '  display: inline-block !important;'
    + '  min-width: 150px !important;'
    + '  text-align: center !important;'
    + '  text-indent: 0 !important;'
    + '  white-space: nowrap !important;'
    + '}'

    /* Cache l icone sprite Swym natif + tout enfant SVG injecté avant (legacy) */
    + '.product__buy-buttons button.swym-add-to-wishlist .swym-icon,'
    + '.product__buy-buttons button.swym-add-to-wishlist > svg,'
    + '.product__buy-buttons .cq-wishlist-placeholder-btn > svg {'
    + '  display: none !important;'
    + '}'

    /* État "Ajouté" — bouton noir + texte+cœur blancs */
    + '.product__buy-buttons button.swym-add-to-wishlist.swym-added,'
    + '.product__buy-buttons button.swym-add-to-wishlist.swym-added.swym-adding,'
    + '.product__buy-buttons button.swym-add-to-wishlist.swym-added[disabled] {'
    + '  background: #131313 !important;'
    + '  color: #ffffff !important;'
    + '  border-color: #131313 !important;'
    + '  opacity: 1 !important;'
    + '  filter: none !important;'
    + '  cursor: pointer !important;'
    + '}'
    + '.product__buy-buttons button.swym-add-to-wishlist.swym-added .swym-wishlist-cta { color: #ffffff !important; opacity: 1 !important; }'
    /* Le pseudo ::before utilise currentColor → suit automatiquement le color du bouton */

    /* Acheter maintenant — bleu marque */
    + '.product-form__checkout .shopify-payment-button__button,'
    + '.product-form__checkout .shopify-payment-button__button--unbranded {'
    + '  background-color: #000DFF !important;'
    + '  color: #ffffff !important;'
    + '  border-color: #000DFF !important;'
    + '}'
    + '.product-form__checkout .shopify-payment-button__button:hover:not([disabled]):not([aria-disabled="true"]),'
    + '.product-form__checkout .shopify-payment-button__button--unbranded:hover:not([disabled]):not([aria-disabled="true"]) {'
    + '  background-color: #000BCC !important;'
    + '  border-color: #000BCC !important;'
    + '}'
    + '.product-form__checkout .shopify-payment-button__button[disabled]:not(.loading),'
    + '.product-form__checkout .shopify-payment-button__button[aria-disabled="true"]:not(.loading),'
    + '.product-form__checkout .shopify-payment-button__button--unbranded[disabled]:not(.loading),'
    + '.product-form__checkout .shopify-payment-button__button--unbranded[aria-disabled="true"]:not(.loading) {'
    + '  background-color: #000DFF !important;'
    + '  color: #ffffff !important;'
    + '  border-color: #000DFF !important;'
    + '  opacity: 1 !important;'
    + '  cursor: pointer !important;'
    + '}'
    + '.product__buy-buttons .product-form__submit[disabled]:not(.loading) {'
    + '  opacity: 1 !important;'
    + '  cursor: pointer !important;'
    + '  background: #ffffff !important;'
    + '  color: #131313 !important;'
    + '  border-color: #131313 !important;'
    + '}';

  if (!document.querySelector('style[data-cards-quest-plan-c]')) {
    var styleEl = document.createElement('style');
    styleEl.setAttribute('data-cards-quest-plan-c', '');
    styleEl.textContent = css;
    document.head.appendChild(styleEl);
  }

  function wantedLabel (btn) {
    return btn.classList.contains('swym-added') ? LABEL_ADDED : LABEL_DEFAULT;
  }

  function setLabel (btn) {
    if (!btn) return;
    var cta = btn.querySelector('.swym-wishlist-cta');
    if (!cta) return;
    var want = wantedLabel(btn);
    if (cta.textContent !== want) cta.textContent = want;
  }

  function attachClassObserver (btn) {
    if (!btn || btn._cqClassObs) return;
    var obs = new MutationObserver(function () { setLabel(btn); });
    obs.observe(btn, { attributes: true, attributeFilter: ['class'] });
    btn._cqClassObs = obs;
  }

  function makePlaceholderBar () {
    var bar = document.createElement('div');
    bar.className = 'cq-wishlist-placeholder';
    bar.setAttribute('data-cq-placeholder', '1');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cq-wishlist-placeholder-btn';
    btn.setAttribute('aria-label', LABEL_DEFAULT);
    /* Pas de SVG enfant — le cœur est rendu par ::before via mask-image */
    var span = document.createElement('span');
    span.className = 'cq-wishlist-label';
    span.textContent = LABEL_DEFAULT;
    btn.appendChild(span);
    bar.appendChild(btn);

    /* Forward click vers le vrai bouton Swym quand prêt */
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var deadline = Date.now() + 8000;
      var iv = setInterval(function () {
        var real = document.querySelector('button.swym-add-to-wishlist');
        if (real) {
          clearInterval(iv);
          real.click();
        } else if (Date.now() > deadline) {
          clearInterval(iv);
        }
      }, 80);
    });

    return bar;
  }

  function ensurePlaceholder () {
    var buttons = document.querySelector('.product-form__buttons');
    if (!buttons) return false;
    var existing = buttons.querySelector(':scope > .swym-button-bar, :scope > .swym-btn-container, :scope > .cq-wishlist-placeholder');
    if (existing) return true;
    var checkout = buttons.querySelector(':scope > .product-form__checkout');
    if (!checkout) return false;
    var bar = makePlaceholderBar();
    buttons.insertBefore(bar, checkout.nextSibling);
    return true;
  }

  function findRealSwymBar () {
    var btn = document.querySelector('button.swym-add-to-wishlist');
    if (!btn) return null;
    var bar = btn.closest('.swym-button-bar') || btn.closest('.swym-btn-container');
    return bar;
  }

  function syncBar () {
    var buttons = document.querySelector('.product-form__buttons');
    if (!buttons) return false;
    var checkout = buttons.querySelector(':scope > .product-form__checkout');
    if (!checkout) return false;
    ensurePlaceholder();
    var real = findRealSwymBar();
    if (real) {
      /* 1. Patche le contenu (label + nettoyage) — la barre est encore invisible (CSS :not([data-cq-ready])) */
      var btn = real.querySelector('button.swym-add-to-wishlist');
      if (btn) {
        var legacySvgs = btn.querySelectorAll('svg.cq-wishlist-icon');
        for (var i = 0; i < legacySvgs.length; i++) legacySvgs[i].remove();
        setLabel(btn);
        attachClassObserver(btn);
      }
      /* 2. Déplace la barre Swym à la bonne position */
      if (real.parentElement !== buttons || real.previousElementSibling !== checkout) {
        buttons.insertBefore(real, checkout.nextSibling);
      }
      /* 3. Marque la barre comme prête → CSS la rend visible */
      real.setAttribute('data-cq-ready', '1');
      /* 4. Supprime le placeholder (atomiquement après le reveal de la real bar) */
      var ph = buttons.querySelector(':scope > .cq-wishlist-placeholder');
      if (ph) ph.remove();
    }
    return true;
  }

  function init () {
    syncBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var globalObs = new MutationObserver(function () { syncBar(); });
  globalObs.observe(document.body, { childList: true, subtree: true });
  setTimeout(function () { globalObs.disconnect(); }, 30000);

  /* === Fix flash variant change : skip le disable préemptif === */
  function patchToggleAddButton () {
    var ctor = customElements.get('variant-selects');
    if (!ctor || !ctor.prototype || ctor.prototype._cqPatchedToggle) return false;
    var orig = ctor.prototype.toggleAddButton;
    if (typeof orig !== 'function') return false;
    ctor.prototype.toggleAddButton = function (disable, text, modifyClass) {
      if (disable === true && (text === '' || text == null) && modifyClass === false) {
        return;
      }
      return orig.apply(this, arguments);
    };
    ctor.prototype._cqPatchedToggle = true;
    return true;
  }
  if (!patchToggleAddButton()) {
    var tries = 0;
    var iv = setInterval(function () {
      if (patchToggleAddButton() || ++tries > 40) clearInterval(iv);
    }, 100);
  }
})();
